<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="shopify_fivetran"
      :logo="shopify"
      :success="success"
      :disconnected="disconnected"
      :warning="warning"
      :processing="processing"
      :error="error"
      :logo-alt="$t('components.tileGroupConnectSales.shopifyLogo')"
      @click="openModal"
    />
    <!-- Shopify Fivetran Modal -->
    <ModalShopifyFivetran
      ref="shopifyFivetranModal"
      @submit="continueShopifyOauth"
      @accountAlreadyConnected="success = true"
      @error="handleError"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
    />
  </span>
</template>

<script>
import { isMobileMixin, modalsRedirectMixin } from '@/utils/vue-mixins';
import { LocalStorage, LocalStorageKeys } from '@/utils/local-storage';
import { SALES_PLATFORMS } from '@/data/platforms';

import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';
import ModalShopifyFivetran from '@/pages/connected-accounts/components/modals/ModalShopifyFivetran.vue';

import shopifyIcon from '@/assets/logos/shopify.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalShopifyFivetran,
  },
  mixins: [isMobileMixin, modalsRedirectMixin],
  props: {
    success: Boolean,
    disconnected: Boolean,
    error: Boolean,
    warning: Boolean,
    processing: Boolean,
  },
  data() {
    return {
      storeName: '',
    };
  },
  computed: {
    shopify: () => shopifyIcon,
  },
  methods: {
    openModal() {
      this.clearOauthParams();
      this.$emit('tileClick', SALES_PLATFORMS.SHOPIFY_FIVETRAN);
      this.$refs.shopifyFivetranModal.open();
    },
    continueShopifyOauth(storeName, authorizeUri) {
      this.storeName = storeName;
      const options = { authorizeUri };
      options.noPopup = true;
      options.redirectRoute = this.redirectRoute;
      LocalStorage.setItem(
        LocalStorageKeys.OAUTH_PROVIDER,
        SALES_PLATFORMS.SHOPIFY_FIVETRAN,
      );
      LocalStorage.setItem(
        LocalStorageKeys.OAUTH_REDIRECT_ROUTE,
        this.redirectRoute,
      );
      this.$emit('submit', options);
    },
    handleError(errorMsg) {
      this.$emit('error', errorMsg);
    },
    clearOauthParams() {
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_PROVIDER);
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_REDIRECT_ROUTE);
    },
  },
};
</script>
